<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/moje-sprawy' aria-label='E-usługi'>Moje sprawy</a>
    </li>
    @if (loading()) {
      <li>
        Ładowanie danych...
      </li>
    } @else {
      <li>
        <a routerLink="../../../"
           [attr.aria-label]="'Szczegóły sprawy nr.: ' + shipment()?.caseEntity?.caseNumber">{{ shipment()?.caseEntity?.caseNumber || 'Brak numeru' }}</a>
      </li>
      <li>
        <a routerLink="../">{{ shipment()?.concerns || 'Szczegóły pisma' }}</a>
      </li>
      <li>
        Status płatności
      </li>
    }
  </app-breadcrumbs>
  @if (!loading()) {
    <section>
      <h2>
        Status płatności
      </h2>
      <app-payment-status-checker [paymentToken]='paymentToken' [canDownload]='true'>
      </app-payment-status-checker>
      <br>
    </section>
    <div class='d-flex justify-content-end'>
      <a routerLink="../../"
         class='btn btn-secondary'>
        Wróć do szczegółów pisma
      </a>
    </div>
  } @else {
    <app-spinner>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  }
</app-content>
